module.exports = __webpack_public_path__ + "img/banner3.96c53fc7.png";